var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm6.488 8.87c-.77.401-1.786.737-2.94.968-.163 1.674-.551 3.152-1.115 4.24a6.553 6.553 0 0 0 4.055-5.208Zm-4.316-.285c.006-.193.01-.388.01-.585 0-3.648-1.16-6.545-2.182-6.545-1.023 0-2.182 2.897-2.182 6.545 0 .209.004.415.011.618.683.072 1.412.11 2.171.11a17 17 0 0 0 2.172-.143Zm1.462-.255.002-.33c0-2.42-.44-4.606-1.203-6.078a6.553 6.553 0 0 1 4.06 5.249c-.342.384-1.421.84-2.86 1.16Zm-5.686 1.763c.653.058 1.34.089 2.052.089.7 0 1.39-.04 2.055-.114-.328 2.617-1.235 4.478-2.055 4.478-.817 0-1.721-1.85-2.052-4.453ZM6.368 10.4a11.238 11.238 0 0 1-1.162-.293c-.902-.283-1.492-.63-1.704-.902a6.552 6.552 0 0 1 4.065-5.283C6.804 5.394 6.364 7.58 6.364 10c0 .134.001.268.004.4Zm.09 1.499c.167 1.649.552 3.104 1.109 4.18a6.554 6.554 0 0 1-4.038-5.086c.76.396 1.76.703 2.929.906Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.5e24886c.svg";
export { ForwardRef as ReactComponent };